/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedOnboardingUsers.defs.js'
export * as $defs from './getSuggestedOnboardingUsers.defs.js'
